import { render, staticRenderFns } from "./TwoFactorSetup.vue?vue&type=template&id=6e762151&"
import script from "./TwoFactorSetup.vue?vue&type=script&lang=js&"
export * from "./TwoFactorSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports